import React, { useState } from "react";
import { UserScreen } from "../../layouts/user-screen.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { Button } from "../../components/buttons/button.tsx";
import { Alert } from "../../components/alerts/alert.tsx";

const textStyle = `font-normal ${FontStyles[`body-l`]}`;
interface VerifyEmailProps {
  email: string;
}

export const VerifyEmailScreen: React.FC<VerifyEmailProps> = (props) => {
  const bgImage = "/static/images/web-promo-teal-narrow.webp";
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState(false);
  const [successful, setSuccessful] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async () => {
    setLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(props.email),
    };

    const response = await fetch("/users/resend-verify-email", requestOptions);
    try {
      if (response.ok) {
        setResend(true);
        setSuccessful(true);
      } else {
        setSuccessful(false);
        setErrorMessage(
          response.status == 409 ? "Account already activated" : "Unable to send email, please try again",
        );
      }
    } catch {
      setSuccessful(false);
      setErrorMessage("Unable to send email, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <UserScreen image={bgImage} headerText={"Please verify your email"} dismissible={false}>
      <div className="flex flex-col gap-4.5 md:gap-6 relative pb-5 px-4.5 md:p-7.5 pt-4.5 md:pt-6">
        {resend && successful && (
          <Alert
            color="green"
            message={`Make sure to check your spam or junk folders.`}
            style="outlined"
            title={"Verification email resent"}
            renderLeadingIcon={() => <i className="fa-sharp fa-regular text-2xl fa-circle-check" />}
          />
        )}
        {!successful && (
          <div className="mb-5">
            <Alert
              color="red"
              message={errorMessage}
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-triangle-exclamation" />}
              style="outlined"
              title="Error"
            />
          </div>
        )}

        <p className={textStyle}>
          Thank you for joining My ESPC! A verification email has been sent to your email address:
        </p>
        <p className="font-bold">{props.email}</p>
        <p className={textStyle}>
          Please click on the link included in the email to complete your registration. Make sure to check your spam
          folder.
        </p>
        <p className={textStyle}>Cannot find the email? No problem. Just click below:</p>
        <Button
          colorVariant="primary"
          label={"Resend verification email"}
          loadingLabel="Sending email..."
          variant="outlined"
          loading={loading}
          disabled={loading}
          onClick={() => void onSubmit()}
        />
      </div>
    </UserScreen>
  );
};
